import React, { useEffect, useState } from 'react';
import { Link, } from '@material-ui/core';
import { Link as RouterLink } from "react-router-dom";
import DataTable, { DataTableColumn } from '../Components/DataTable';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import { Setting } from './AdminModels';

interface SettingTableProps {
    items: Setting[];
    onSelect? : (item : Setting) => void;
}

const SettingTable: React.FC<SettingTableProps> = (props) => {
    const [selectedId, setSelectedId] = useState<number>(0);
    const [columns, setColumns] = useState<DataTableColumn<Setting>[]>([]);
 
    useEffect(() => {
      refreshColumns();
    }, []);
    
    const refreshColumns = () => {
      var cols: DataTableColumn<Setting>[] = [
        { id: 'id', numeric: true, disablePadding: true, label: "Setting Id", filterEnabled: true },
        { id: 'name', numeric: false, disablePadding: false, label: 'Setting', filterEnabled: true },
        { id: 'value', numeric: false, disablePadding: false, label: 'Value', filterEnabled: true },
        { id: 'createdAt', numeric: false, disablePadding: false, label: 'Created at', renderValue: (item: Setting) => { return CreateRoundUtil.toGameDateString(item.createdAt); } },
      ];
      setColumns(cols);
    }
    const onSelect = (item : Setting) => {
        setSelectedId(item.id);
        if (props.onSelect){
          props.onSelect(item);
          return;
      }
    };
    return (
      <DataTable columns={columns} items={props.items} getId={it => it.id} orderBy='id' order='asc' resultFilterEnabled={true} size='xsmall' onSelect={onSelect} rowsPerPage={25}  />
    );
  };
  
  export default SettingTable;
 